/* eslint-disable no-untranslated-string/no-untranslated-string */
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const customMerge = extendTailwindMerge({
  override: {
    classGroups: {
      shadow: ['shadow-button'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customMerge(clsx(inputs));
}
